import axios from 'axios'
import {Action} from 'redux'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {put, takeLatest, takeLeading} from 'redux-saga/effects'
import {APIResponse} from '../../../models/HelperModel'
import {ISatuanIndikatorKinerja} from '../../../models/RFSatuanIndikator'

interface ActionWithPayload<T> extends Action {
  payload: T
}

const actionTypes = {
  InitRFSatuanIndikator: '[Init RF Satuan Indikator]',
  SetRFSatuanIndikator: '[Set RF Satuan Indikator] Action',
}

const initialRFSatuanIndikator: IRFSatuanIndikator = {
  rfSatuanIndikator: [] as ISatuanIndikatorKinerja[],
}

interface IRFSatuanIndikator {
  rfSatuanIndikator?: ISatuanIndikatorKinerja[]
}

export const reducer = persistReducer(
  {storage: storage, key: 'rf-satuan-indikator', whitelist: ['rfSatuanIndikator']},
  (
    state: IRFSatuanIndikator = initialRFSatuanIndikator,
    action: ActionWithPayload<IRFSatuanIndikator>
  ) => {
    switch (action.type) {
      case actionTypes.InitRFSatuanIndikator: {
        return {...state, rfSatuanIndikator: [] as ISatuanIndikatorKinerja[]}
      }
      case actionTypes.SetRFSatuanIndikator: {
        return {...state, rfSatuanIndikator: action.payload.rfSatuanIndikator}
      }

      default:
        return state
    }
  }
)

export const actions = {
  initRFSatuanIndikator: () => ({type: actionTypes.InitRFSatuanIndikator}),
  SetRFSatuanIndikator: (RFSatuanIndikator: ISatuanIndikatorKinerja[]) => ({
    type: actionTypes.SetRFSatuanIndikator,
    payload: {rfSatuanIndikator: RFSatuanIndikator},
  }),
}

export function* saga() {
  yield takeLeading(
    actionTypes.InitRFSatuanIndikator,
    function* requestSatuanIndikator({
      type,
      payload,
    }: {
      type: typeof actionTypes.SetRFSatuanIndikator
      payload: {rfSatuan: ISatuanIndikatorKinerja[]}
    }) {
      const {
        data: {data: a},
      } = yield getRFSatuanIndikator()
      yield put(actions.SetRFSatuanIndikator(a))
    }
  )
}

function getRFSatuanIndikator() {
  const API_URL = process.env.REACT_APP_API_URL
  const RF_SATUAN_INDIKATOR = `${API_URL}/pksatuan`
  return axios.get<APIResponse<ISatuanIndikatorKinerja[]>>(RF_SATUAN_INDIKATOR)
}
